import type { z } from "zod";
import type { Contact } from "../contact.types";
import type { contactSchema } from "../schemas/contact.schema";
import { contactResponseSchema } from "../schemas/contact.schema";

export function parseContact(raw: z.infer<typeof contactSchema>): Contact {
    return raw;
}

export function parseContactResponse(raw: unknown): Contact | undefined {
    const result = contactResponseSchema.safeParse(raw);
    if (!result.success) return undefined;
    return result.data.getContact;
}
